@if (isBrowser) {
  <app-cookie-banner></app-cookie-banner>
}
<router-outlet/>
@if (isBrowser) {
  <app-toast/>
  <app-spinner [isAdmin]="isAdmin"/>
}

